module.exports = __webpack_public_path__ + "media/src/images/logos/dialogflow-d5489d2f6cab5f368ad54e7ef99ec0c2.png";